import type { ApolloClient } from '@apollo/client';
import { GET_CURRENT_SERVER_TIME_MILLIS, type GetCurrentServerTimeMillisResponse } from '../graphql/queries/serverTimeQueries';

/**
 * 获取服务端当前时间戳（毫秒），用于水印时间，避免依赖设备时钟被篡改
 * @param apolloClient Apollo Client 实例
 * @returns 毫秒时间戳，失败时返回 undefined
 */
export async function getCurrentServerTimeMillis(
  apolloClient: ApolloClient<unknown>
): Promise<number | undefined> {
  try {
    const res = await apolloClient.query<GetCurrentServerTimeMillisResponse>({
      query: GET_CURRENT_SERVER_TIME_MILLIS,
      fetchPolicy: 'network-only'
    });
    const sec = res.data?.health;
    const secNum = sec != null ? Number(sec) : NaN;
    if (Number.isFinite(secNum) && secNum > 0) {
      return Math.floor(secNum * 1000);
    }
  } catch {
    // 网络失败时返回 undefined，调用方使用设备时间
  }
  return undefined;
}
